import * as React from "react";
import UnderlineDropdown, { TUnderlineDropdownItem } from "./underline-dropdown/underline-dropdown";

export type TGoalTypeDropdownProps = {
	name: string,
	value?: any,
	options?: any,
	placeHolder?: string,
	className?: string,
	onChange?: (event: any) => void,
	onBlur?: (event: any) => void,
	onKeyPress?: (event: any) => void,
	showError?: boolean,
	errorText?: string,
	type?: string,
	isDisabled?: boolean,
	smallDropdown?: boolean
};

const OtherIncomeSourceTypeDropdown: React.FC<TGoalTypeDropdownProps> =
	({name, value, options, className, onChange, isDisabled, smallDropdown}) => {
		const dropdownItems: TUnderlineDropdownItem[] = [] as TUnderlineDropdownItem[];

		for (const item in options) {
			if (!isNaN(Number(item))) {
				dropdownItems.push({
					value: options[item].IncomeSourceTypeId,
					text: String(options[item].IncomeSourceType)
				});
			}
		}

		return (
			<UnderlineDropdown
				name={name}
				value={value ? String(value) : 0}
				options={dropdownItems}
				onChange={onChange}
				isDisabled={isDisabled}
				className={className}/>
		);
	};

export default OtherIncomeSourceTypeDropdown;